import { usePatientConsultations } from '@/hooks/patients/usePatientConsultations';
import { useMemo } from 'react';

interface useScheduledConsultProps {
  patientId?: number;
  scheduledConsultId?: number;
}

export const useScheduledConsult = ({ patientId, scheduledConsultId }: useScheduledConsultProps) => {
  const {
    patientConsultationsData,
    isFetchingPatientConsultations,
    isPatientConsultationsError,
    isPatientConsultationsSuccess,
    isPatientConsultationsPending,
  } = usePatientConsultations(patientId);

  const scheduledConsult = useMemo(() => {
    if (!scheduledConsultId || !isPatientConsultationsSuccess) {
      return undefined;
    }
    return patientConsultationsData.find((c) => c.id === scheduledConsultId);
  }, [scheduledConsultId, isPatientConsultationsSuccess, patientConsultationsData]);

  const isNotFound = useMemo(() => {
    // Not found if we're not loading, have data, but no matching consultation
    return (
      !isFetchingPatientConsultations &&
      isPatientConsultationsSuccess &&
      scheduledConsultId !== undefined &&
      !scheduledConsult
    );
  }, [isFetchingPatientConsultations, isPatientConsultationsSuccess, scheduledConsultId, scheduledConsult]);

  return {
    scheduledConsult,
    isLoading: isFetchingPatientConsultations,
    isError: isPatientConsultationsError,
    isPending: isPatientConsultationsPending,
    isNotFound,
  };
};
